// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-hZJ","inner":"Footer_inner__wE2z9"};